// The classroom's lesson clock (#711). Pure so it can be tested without a timer:
// the component feeds it `Date.now()` each second.

const MINUTE_MS = 60_000

// The warning before the end of the booked time, and the one before Daily closes
// the room (the room expires JOIN_WINDOW's 60 minutes after ends_at and ejects
// everybody, see DailyService::ROOM_EXP_BUFFER).
export const ENDING_SOON_MS = 5 * MINUTE_MS
export const ROOM_CLOSES_AFTER_END_MS = 60 * MINUTE_MS
export const ROOM_CLOSING_SOON_MS = 10 * MINUTE_MS

export type LessonClockPhase = "running" | "overtime"

export interface LessonClockState {
  phase: LessonClockPhase
  // Milliseconds left to ends_at while running; milliseconds past it in overtime.
  ms: number
}

export function lessonClockState(endsAtMs: number, nowMs: number): LessonClockState {
  const left = endsAtMs - nowMs
  return left > 0 ? { phase: "running", ms: left } : { phase: "overtime", ms: Math.max(0, -left) }
}

// 49:05, or 1:02:09 past the hour. Seconds are rounded up while counting down so
// the display never shows 0:00 with time still left.
export function formatClock(ms: number, phase: LessonClockPhase = "running"): string {
  const totalSeconds = Math.max(0, phase === "running" ? Math.ceil(ms / 1000) : Math.floor(ms / 1000))
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const pad = (n: number) => String(n).padStart(2, "0")
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`
}

export type LessonClockWarning = "endingSoon" | "roomClosing"

// Which one-shot warnings are due at `nowMs`. A participant who joins late is
// still told, once, about the warning whose moment they walked into.
export function dueWarnings(endsAtMs: number, nowMs: number): LessonClockWarning[] {
  const due: LessonClockWarning[] = []
  const left = endsAtMs - nowMs
  if (left > 0 && left <= ENDING_SOON_MS) due.push("endingSoon")
  if (-left >= ROOM_CLOSES_AFTER_END_MS - ROOM_CLOSING_SOON_MS && -left < ROOM_CLOSES_AFTER_END_MS) {
    due.push("roomClosing")
  }
  return due
}
